import chatModule from '../chatModule';

function dialogVoiceUi(resources) {
    "ngInject";

    return {
        restrict: 'A',
        replace: true,
        scope: true,
        templateUrl: resources.templates.dialogVoiceUi
    }
};

chatModule.directive("dialogVoiceUi", dialogVoiceUi);

export default dialogVoiceUi;